import React from "react";
import { Button } from "./ui/button";
import { Volume2, Square, Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import useHeroNarrator from "../hooks/useHeroNarrator";

const HeroNarrateButton = ({ text, hero = "neutral", label = "Listen", size = "sm", className = "", guided = false }) => {
  const { play, stop, loading, playing } = useHeroNarrator();
  const { i18n } = useTranslation();
  const lang = (i18n.language || "en").slice(0, 2);

  const onClick = () => {
    if (playing) stop();
    else play(text, hero, true, lang, guided);
  };

  return (
    <Button
      size={size}
      variant="outline"
      onClick={onClick}
      disabled={loading || !text}
      className={`gap-2 ${className}`}
      data-testid={`hero-narrate-btn-${hero}`}
    >
      {loading ? (
        <Loader2 className="w-4 h-4 animate-spin" />
      ) : playing ? (
        <Square className="w-4 h-4 fill-current" />
      ) : (
        <Volume2 className="w-4 h-4" />
      )}
      <span>{playing ? "Stop" : label}</span>
    </Button>
  );
};

export default HeroNarrateButton;
